import { render } from "./InstanceTable.vue?vue&type=template&id=05b56528&scoped=true&ts=true"
import script from "./InstanceTable.vue?vue&type=script&lang=ts"
export * from "./InstanceTable.vue?vue&type=script&lang=ts"

import "./InstanceTable.vue?vue&type=style&index=0&id=05b56528&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b56528"]])

export default __exports__